const contact_page = document.getElementById("contact-page");

if (contact_page) {
  //# Form elements
  const contact_form = contact_page.querySelector("#contact-form");
  const btn_submit = contact_form.querySelector("button");
  // const input_groups = contact_form.querySelectorAll("label");
  const inputs = contact_form.querySelectorAll("input, textarea");
  const status_labels = contact_form.querySelectorAll("span[data-status]");
  const response_message = contact_form.querySelector(".response-message");


  let isPosting = false;

  btn_submit.onclick = async (event) => {
    event.preventDefault();

    //% Exit if already posting
    if (isPosting) {
      return;
    }

    //% Set status to posting and trigger busy class on form
    isPosting = set_post_status(true, contact_form);

    const formData = new FormData(contact_form);
    const url =
      window.origin + "/wp-json/contact-form-7/v1/contact-forms/32/feedback";
    const options = {
      method: "POST",
      body: formData,
    };

    //% Remove Status Errors and Response Message while submitting
    contact_form_remove_status(status_labels);
    response_message.innerText = "";

    try {
      const request = await fetch(url, options);

      //% Throw error message is request fails
      if (!request.ok) {
        throw new Error(
          "Request has faileed with status code: " +
            request.status +
            " - " +
            request.statusText
        );
      }

      const response = await request.json();
      // console.log(response);

      //% If request was successful, clear input fields and set response message
      if (response.status === "mail_sent") {
        //$ Clear inputs
        contact_form_clear_inputs(inputs);

        //$ Set response message
        response_message.innerText = response.message;

        //$ Set status to not posting
        // return (isPosting = false);
        return (isPosting = set_post_status(false, contact_form));
      }

      //% If there are invalid fields, add status class to input groups and set response message
      if (response.invalid_fields.length) {
        //$ Loop over each invalid field
        response.invalid_fields.forEach((invalid_field) => {
          //$ Define required variables
          const field = invalid_field.field;
          const status = invalid_field.message;
          const label = contact_form.querySelector(`span[data-field=${field}]`);

          //$ Set response label's text to the error message
          label.innerText = status;
          //$ Add error class to the label
          label.classList.add("error");
        });

        //$ Set response message
        response_message.innerText = response.message;

        //% Set status to not posting
        // return (isPosting = false);
        return (isPosting = set_post_status(false, contact_form));
      }

      //$ If there was some other kind of outcome (no mail sent and no invalid fields then throw error)
      throw new Error(response.message);
    } catch (error) {
      //% Set failure response message
      response_message.innerText =
        "There was an error trying to send your message. Please try again later.";
      console.error(error);
    }

    //% Set status to not posting
    // isPosting = false;
    return (isPosting = set_post_status(false, contact_form));

  };
}

function set_post_status(post_state, contact_form = null) {
  if ( contact_form ) {
    contact_form.classList.toggle("busy-posting");
  }
  return post_state;
}

function contact_form_clear_inputs(inputs_array) {
  if (!inputs_array) {
    return;
  }
  inputs_array.forEach((input) => {
    input.value = "";
  });
}

function contact_form_remove_status(status_labels) {
  status_labels.forEach((label) => {
    label.innerText = "";
    label.classList.remove(...label.classList);
  });
}
